module.exports = __webpack_public_path__ + "img/news-icon-look@2x.e6eee854.svg";